var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classes,attrs:{"id":"app"}},[_c('header',{staticClass:"header",style:(_vm.headerStyles)},[_c('nav-bar'),_vm._v(" "),_vm._t("title-header")],2),_vm._v(" "),_vm._t("title-body"),_vm._v(" "),_c('main',[_vm._t("default")],2),_vm._v(" "),_c('footer-bar')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }